import { CartProductCode } from '@ace-clublabs/common-membership-api-types';
export interface IGetMemberPricesRequest {
  guid: string;
  transactionType: CalculatorTransactionType;
  virtualId?: string;
}

export interface IGetMemberPricesResponse {
  data: any;
  error?: {
    message: string;
  };
}

export interface MemberPriceSummary {
  membershipLevel: string;
  firstName: string;
  lastName: string;
  cartItems: RejoinCartItem[];
  savings: string;
  promoCode?: string;
  enrollInAutoPay: boolean;
  enrollInAutoPayDescription: string;
  total: string;
}

export interface RejoinCartItem {
  id: string;
  seqNo: number;
  itemCode: CartProductCode;
  description: string;
  price: string;
  allowDelete: boolean;
  deleted: boolean;
}

export enum CalculatorTransactionType {
  INITIALIZE = 'INITIALIZE',
  DELETE_MEMBER = 'DELETE_MEMBER',
  ENROLL_IN_AUTOPAY = 'ENROLL_IN_AUTOPAY',
  UNENROLL_IN_AUTOPAY = 'UNENROLL_IN_AUTOPAY',
  DELETE_PRODUCT = 'DELETE_PRODUCT',
}
